import { useEffect, useLayoutEffect, useState } from "react"
import { useSnapCarousel } from "@/hooks/use-snap-carousel"

export function useOverflowSnapCarousel(refreshKey?: unknown) {
  const {
    scrollRef: snapScrollRef,
    pages,
    activePageIndex,
    goTo,
    prev,
    next,
    refresh,
  } = useSnapCarousel({ contentKey: refreshKey })
  const [canScroll, setCanScroll] = useState(false)
  const [scrollEl, setScrollEl] = useState<HTMLElement | null>(null)

  const setScrollRef = (el: HTMLElement | null) => {
    setScrollEl(el)
    snapScrollRef(el)
    setCanScroll(el ? el.scrollWidth > el.clientWidth : false)
  }

  useLayoutEffect(() => {
    refresh()
  }, [refresh, refreshKey])

  useEffect(() => {
    if (!scrollEl) return

    const update = () => {
      setCanScroll(scrollEl.scrollWidth > scrollEl.clientWidth)
      refresh()
    }

    update()
    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(scrollEl)

    return () => resizeObserver.disconnect()
  }, [refresh, refreshKey, scrollEl])

  return {
    scrollRef: setScrollRef,
    canScroll,
    pages,
    activePageIndex,
    goTo,
    prev,
    next,
  }
}
